import { FilterTable } from "@/features/FilterTable/FilterTable";
import { Field } from "@/features/FilterTable/types";
import { dateSchema, parseToDateValue } from "@/features/FormCard/utils";
import { z } from "zod";

export const filterAhoyEventsSchema = z.object({
  name_contains: z.string().nullable().optional(),
  user_email_contains: z.string().nullable().optional(),
  time_from: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
  time_to: z
    .preprocess((val) => parseToDateValue(val as string), dateSchema)
    .optional(),
});

export type FilterAhoyEventsSchema = z.infer<typeof filterAhoyEventsSchema>;

export const fields: Field[] = [
  {
    name: "name_contains",
    label: "Event Name",
    type: "input",
  },
  {
    name: "user_email_contains",
    label: "User Email",
    type: "input",
  },
  {
    name: "time_from",
    label: "Time From",
    type: "date",
  },
  {
    name: "time_to",
    label: "Time To",
    type: "date",
  },
];

export const client = "qtl - admin";

export function FilterAhoyEvents() {
  return (
    <FilterTable
      client={client}
      schema={filterAhoyEventsSchema}
      tableName="ahoy_events"
      customBuildPath={() => `${client}/events`}
      fields={fields}
    />
  );
}
